"use client";
import React from "react";
import { createPortal } from "react-dom";
import { useModal } from "../ModalRoot/ModalRoot";

interface ModalPortalProps {
  children: React.ReactNode;
  portalRef?: HTMLElement | null;
}

const ModalPortal = ({ children, portalRef }: ModalPortalProps) => {
  const { mounted } = useModal();
  return mounted && createPortal(children, portalRef ?? document.body);
};

export default ModalPortal;
